// @ts-nocheck
import { Navigate, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import useAuth from '../hooks/useAuth';
import { setPendingPath } from '../services/pendingIntent';
import { canCheckInBeforeOnboarding } from '../services/onboardingTeam';

OnboardingGuard.propTypes = {
  children: PropTypes.node,
  // The check-in screens: let a person whose company is settled through
  // before the wizard is done (canCheckInBeforeOnboarding).
  allowCheckIn: PropTypes.bool
};

export default function OnboardingGuard({ children, allowCheckIn = false }) {
  const { user } = useAuth();
  const { pathname, search } = useLocation();

  if (!user?.onboardingCompleted && !(allowCheckIn && canCheckInBeforeOnboarding(user))) {
    // A brand-new (authed but not-yet-onboarded) worker who scanned a QR
    // deep-link (/m/...): stash the full path so onboarding completion can
    // replay it instead of stranding them on /dashboard.
    if (pathname.startsWith('/m/')) {
      setPendingPath(pathname + search);
    }
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
}
